import React from "react";
import { AuthRoles } from "components/auth";

export const AccountsReceivableConfig = {
  auth: AuthRoles.admin,
  routes: [
    {
      path: `${process.env.PUBLIC_URL}/accounts_receivable`,
      component: React.lazy(() => import("./AccountsReceivable")),
    },
  ],
};
